export default {
      id: "last-usage",
      viewBox: "0 0 13 13",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#last",
      toString: function () {
        return this.url;
      }
    }